import styled from "styled-components";

const Button = styled.button`
    min-height: 50px;
    background-color: #333;
    color: #fff;
    font-size: 18px;
    padding: 0 0.8em;
    transition: opacity 0.2s linear 0s;
    width: 60%;
    &:hover {
        color: #fff;
        background-color: #444;
    }
`;
export default Button;
